import { SettlementsService } from 'src/app/services/settlements.service';
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-transaction-fail',
  template: `
    <div class="d-flex">
      <div class="flex-fill flex-column justify-content-center align-items-center" style="width: 340px; max-width: 340px; margin: 0 auto;">
        <div class="card border rounded-4 bg-white shadow">
          <div class="card-body px-4 py-3">
            <div class="d-flex justify-content-center mb-4">
              <div class="flex-fill text-center">
                <div class="text-center mt-5">
                  <h2 class="card-title mb-4">Pago falló</h2>
                  <p class="mb-0">El pago no se realizó de manera exitosa.</p>
                </div>
                <div class="text-center mt-5">
                  <p class="text-danger mb-0">Por favor revisa con tu banco e intenta de nuevo más tarde.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class TransactionFailComponent {
  billId: number = 0;
  bill: any = {};
  transaction: any = {};
  loading: boolean = true;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private settlementsService: SettlementsService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.billId = params['id'];
      this.settlementsService.getBill(this.billId).subscribe((data: any) => {
        this.bill = data;
        this.settlementsService.getTransactionByBill(this.billId).subscribe((transaction: any) => {
          this.transaction = transaction;
          this.loading = false;
        });
      });
    });
  }

  ngOnInit(): void {}

  cardType(cardType: string) {
    let card: string = '';
    if (cardType === 'VI') {
      card = "assets/images/icon-visa-sm.png";
    } else if (cardType === 'MC') {
      card = "assets/images/icon-mastercard-sm.png";
    } else if (cardType === 'AMEX') {
      card = "assets/images/icon-amex-sm.png";
    }
    
    return card;
  }
}
